<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="visitor-card shadow border-primary">
          <div class="card-body">
            <!-- Main component -->
            <!-- ASSETS TABLE -->
             <div v-show="is_loading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Asset List...</p>
            </div>
            <div v-show="!is_loading">
            <div v-if="community_assets && community_assets.length">
                <div class="table-responsive">
                    <div class="float-end">
                        <GetCommunityAssets ref="communityAssets" />
                    </div>
                    <table class="table align-middle table-striped table-borderless mb-0 data-table">
                        <thead class="text-uppercase btn-primary text-white sticky-top">
                            <tr>
                                <th class="text-xxs fw-light">No.</th>
                                <th class="text-xxs fw-light text-center">Asset</th>
                                <th class="text-xxs fw-light text-center">Category</th>
                                <th class="text-xxs fw-light text-center">Location</th>
                                <th class="text-xxs fw-light text-center">Created By</th>
                                <th class="text-xxs fw-light text-center">Status</th>
                                <th class="text-xxs fw-light text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(asset, index) in community_assets"
                                :key="asset.id"
                                class="border-bottom text-xxs"
                                >
                                <td class="text-center">
                                    <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                                    {{ index + 1 }}
                                    </span>
                                </td>
                                <td>
                                    <div class="fw-600">{{ asset.name }}</div>
                                    <div class="text-muted small">
                                    {{ (asset.description && asset.description.length > 110) ? asset.description.slice(0, 110) + '…' : asset.description }}
                                    </div>
                                </td>
                                <td>
                                    <span class="chip chip-secondary text-xxs">
                                    {{ asset.category?.name || '—' }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    {{ asset.location || '—' }}
                                </td>
                                <td>
                                    {{ asset.creater?.full_name || asset.creater?.name || '—' }}
                                </td>
                                <td class="text-center">
                                    <span
                                    class="badge text-xxs rounded text-capitalize"
                                    :class="{
                                        'bg-success': asset.is_booked === false,
                                        'bg-warning': asset.is_booked === true,
                                    }"
                                    >
                                    {{ asset.is_booked ? 'booked' : 'available' }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center gap-1">
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-primary border text-xxs"
                                            data-bs-toggle="modal"
                                            data-bs-target="#bookingsListModal"
                                            @click.stop.prevent="asset_bookings(asset)">
                                            View
                                        </button>
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-success border text-xxs"
                                            v-if="!asset.is_booked"
                                            @click.stop.prevent="edit_asset(asset)">
                                            Edit
                                        </button>
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-danger border text-xxs"
                                            v-if="(current_role === 'admin' || asset.creater?.id === current_user_id) && !asset.is_booked"
                                            @click.stop.prevent="delete_asset(asset.id, $event)"
                                            >
                                            Delete
                                        </button>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Empty state -->
            <div v-else class="text-center py-5">
                <i class="bi bi-box-seam display-1 text-muted mb-3" aria-hidden="true"></i>
                <p class="text-muted fs-5 mb-1">No assets yet.</p>
                <p class="text-muted text-xxs mb-3">When you create assets, they will appear here.</p>
                <GetCommunityAssets class="justify-content-center align-items-center" ref="communityAssets" />
            </div>
            </div>
            <!-- /ASSETS TABLE -->
          </div>
        </div>
      </div>
      <!-- /Content column -->
    </div>
  </div>
</div>
